module.exports = __webpack_public_path__ + "img/topaz.be5030ca.webp";